import React from "react";
import ActionsIcon from "../../images/actions-icon.svg";
import Icon from "@ant-design/icons";

export default function Actions() {
    return <Icon component={ActionsIcon as any} />
}